import {Component, computed, inject, input, output, ChangeDetectionStrategy} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {map} from 'rxjs';
import {CommonModule} from '@angular/common';

import {FormControl, FormGroup} from "@angular/forms";
import {BreakpointObserver} from "@angular/cdk/layout";
import {HOME_URL} from "../../../../models/home/navigation.model";
import {Router} from "@angular/router";
import {TranslatePipe} from "@ngx-translate/core";
import {IconButtonComponent} from 'src/app/modules/design-system/icon-button/icon-button.component';
import {MultiSelectComponent} from 'src/app/modules/design-system/multi-select/multi-select.component';
import {SelectTriggerComponent} from 'src/app/modules/design-system/multi-select/select-trigger/select-trigger.component';
import {SelectOptionComponent} from 'src/app/modules/design-system/multi-select/select-option/select-option.component';
import {TextButtonComponent} from 'src/app/modules/design-system/text-button/text-button.component';

@Component({
  selector: 'app-onboarding-step-2',
  standalone: true,
	imports: [CommonModule, IconButtonComponent, MultiSelectComponent, SelectTriggerComponent, SelectOptionComponent, TextButtonComponent, TranslatePipe],
  templateUrl: './onboarding-step-2.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: '../onboarding.component.scss'
})
export class OnboardingStep2Component {
	private router = inject(Router);

	protected readonly form: FormGroup = new FormGroup({
		'userKind': new FormControl('cio'),
		'workPlace': new FormControl('group'),
		'objectives': new FormControl('mapping'),
	});

	readonly stepCount = input.required<number>();
	readonly canClose = input(false);
	readonly isMobile = input.required<boolean>();

	readonly onNextClick = output<FormGroup>();

	private readonly compact = toSignal(inject(BreakpointObserver).observe(['(max-width: 1280px)']).pipe(map(state => state.matches)), {initialValue: false});
	protected readonly height = computed(() => this.compact() ? 35 : 60);
	protected readonly panelClass = computed(() => this.compact() ? '' : 'big-button');
	protected readonly fontSize = computed<'S' | 'L'>(() => this.compact() ? 'S' : 'L');

	goToNextStep() {
		this.onNextClick.emit(this.form);
	}

	goBackHome() {
		return this.router.navigate([HOME_URL])
	}
}
